import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../../Formik'
import Text from '../../../../../../Text'
import { TextareaOutlineField } from '../../../../../../Textarea'
import {
  APPLICANT_DECISION_NOTE_MAX_LENGTH,
  APPLICANT_DECISION_NOTE_PLACEHOLDER_KEY,
  QA_NAME_APPLICANT_DECISION_NOTE_INPUT,
} from '../../ApplicantDecisionPanel.constants'
import {
  APPLICANT_DECISION_NOTE_FIELD_MIN_ROWS,
  APPLICANT_DECISION_NOTE_FIELD_NAME,
} from '../ApplicantDecisionModal.constants'

import * as styles from './ApplicantDecisionModalFields.module.css'

function ApplicantDecisionModalFields({ action, description }) {
  const { t } = useTranslation()

  const noteRef = useRef(null)

  useEffect(() => {
    noteRef.current?.focus()
  }, [])

  return (
    <div className={styles.ApplicantDecisionModalFields}>
      <Text>{description}</Text>
      <FormikField
        withoutManualResize
        Component={TextareaOutlineField}
        elementRef={noteRef}
        getErrorProps={getFormikFormFieldErrorProps}
        maxLength={APPLICANT_DECISION_NOTE_MAX_LENGTH}
        minRows={APPLICANT_DECISION_NOTE_FIELD_MIN_ROWS}
        name={APPLICANT_DECISION_NOTE_FIELD_NAME}
        placeholder={t(APPLICANT_DECISION_NOTE_PLACEHOLDER_KEY[action])}
        qaName={QA_NAME_APPLICANT_DECISION_NOTE_INPUT}
      />
      <Text isSecondary className={styles.guardrail}>
        {t('RentalPortal.ApplicantDecisionNoteGuardrailKey')}
      </Text>
    </div>
  )
}

export default ApplicantDecisionModalFields
